<template>
    <div id="engineerManage">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <el-form-item style="width:150px;margin-bottom:15px">
                <el-select clearable filterable :filter-method="PinyinMatch" @change="changeName" v-model="searchForm.name" placeholder="工程师">
                    <el-option v-for="item,index in engineersList"
                        :key="index"
                        :label="item.name"
                        :value="item.name">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:160px;margin-bottom:15px">
                <el-input clearable v-model.trim="searchForm.number" placeholder="请输入工程师账号"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px">
                <el-select clearable filterable v-model="searchForm.type" placeholder="请选择工程师类型">
                    <el-option
                        v-for="item,index in engineerTypeList"
                        :key="index"
                        :label="item.paraName"
                        :value="item.paraCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:150px;margin-bottom:15px">
                <el-select clearable filterable v-model="searchForm.shop" placeholder="请选择所属门店">
                    <el-option
                        v-for="item,index in shopListData"
                        :key="index"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="启用状态：" style="width:200px;margin-bottom:15px" prop="state" label-width="100px">
                <el-switch v-model="searchForm.state" :active-value="1":inactive-value="-1" ></el-switch>
            </el-form-item>
            <el-form-item style="margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
            </el-form-item>
            <el-form-item class="fr">
                <el-col style="text-align:right">
                    <el-button size="medium" type="success" @click="createEngineer()" v-if="basicsAuth.storeEngineerAdd" >新建工程师</el-button>
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                </el-col>
            </el-form-item>
        </el-form>
        <el-card class="box-card" style="width: 100%;">
            <el-table
                :data="returnData"
                border
                id="tableId"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    prop="name"
                    label="工程师姓名"
                    width="120">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="loginName"
                    label="工程师账号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="type"
                    label="工程师类别">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 'SM'">上门工程师</span>
                        <span v-else>门店工程师</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="attribute2"
                    label="工程师等级">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="attribute3"
                    label="基础包">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="启用状态">
                    <template  slot-scope="scope">
                        <span v-if="scope.row.state == 1">启用</span>
                        <span v-else>禁用</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作" v-if="basicsAuth.storeEngineerEdit">
                    <template slot-scope="scope">
                        <el-button @click.stop="exitBtn(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
            <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogCreate" :close-on-click-modal="false" width="600px" @close="emptyDialog()">
                <el-form ref="EngineerForm" :rules="EngineerFormRules" :model="EngineerForm" label-width="65px" :label-position="labelPosition">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="类型" prop="type">
                                <el-select clearable filterable v-model="EngineerForm.type" placeholder="请选择工程师类型" style="width: 100%;">
                                    <el-option v-for="item,index in engineerTypeList" :key="index" :label="item.paraName" :value="item.paraCode"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="姓名"  prop="name">
                                <el-input clearable v-model.trim="EngineerForm.name" placeholder="请输入姓名" ></el-input>
                            </el-form-item>
                            <el-form-item label="城市"  prop="accountState">
                                <el-select clearable filterable v-model.trim="EngineerForm.accountState" placeholder="请选择城市" style="width: 100%;">
                                    <!-- <el-option label="上海"  value="1"></el-option>
                                    <el-option label="北京"  value="2"></el-option> -->
                                    <el-option
                                        v-for="(item,index) in regionList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="账号"  prop="loginName">
                                <el-input clearable v-model.trim="EngineerForm.loginName" placeholder="请输入账号" ></el-input>
                            </el-form-item>
                            <el-form-item label="等级" prop="grade">
                                <el-select clearable filterable v-model="EngineerForm.grade" placeholder="请选择工程师等级" style="width: 100%;">
                                    <el-option v-for="item,index in enginnerGradeList" :key="index" :label="item.gradeName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="号码"  prop="phone">
                                <el-input clearable type="text" v-model.trim="EngineerForm.phone" placeholder="请输入手机号码" style="margin-bottom: 15px;"></el-input>
                            </el-form-item>
                            <el-form-item label="工号"  prop="jobNo">
                                <el-input clearable type="text" v-model.trim="EngineerForm.jobNo" placeholder="请输入工号" style="margin-bottom: 15px;"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="门店" prop="shop">
                                <el-select clearable filterable v-model="EngineerForm.shop" placeholder="请选择所属门店" style="width: 100%;">
                                    <el-option v-for="item,index in shopListData" :key="index" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="性别"  prop="sex">
                                <el-select clearable v-model="EngineerForm.sex" autocomplete="off" placeholder="请选择性别" style="width: 100%;">
                                    <el-option label="男" value="1"></el-option>
                                    <el-option label="女" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="dialogMenuStatus=='create'" label="密码"  prop="password">
                                <el-input clearable type="password" v-model.trim="EngineerForm.password" placeholder="请输入工程师密码" ></el-input>
                            </el-form-item>
                            <el-form-item v-if="dialogMenuStatus=='update'" label="密码" >
                                <el-input clearable type="password" v-model.trim="EngineerForm.password" placeholder="请输入工程师密码" ></el-input>
                            </el-form-item>
                            <el-form-item label="基础包" prop="packType">
                                <el-select clearable filterable v-model="EngineerForm.packType" placeholder="请选择基础包" style="width: 100%;">
                                    <el-option v-for="item,index in enginnerPackTypeList" :key="index" :label="item.packName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="邮箱" prop="email">
                                <el-input clearable type="email" v-model.trim="EngineerForm.email" placeholder="请输入邮箱"></el-input>
                            </el-form-item>
                            <el-form-item label="年龄" prop="age">
                                <el-input clearable type="number" v-model.trim="EngineerForm.age" placeholder="请输入年龄" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="启用状态：" prop="state" label-width="100px">
                        <el-switch v-model="EngineerForm.state" :active-value="1":inactive-value="-1" ></el-switch>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button v-if="dialogMenuStatus=='create'" type="primary" @click="createData('EngineerForm')">立即创建</el-button>
                    <el-button v-else type="primary" @click="updateData('EngineerForm')">保存</el-button>
                    <el-button @click="emptyDialog()">取消</el-button>
                </div>
            </el-dialog>
        </el-card>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        engineerList,engineerInfoAdd,engineerInfoByUser,
        engineerInfoTypeList,engineerGreadeList,packTypeList,shopStoreList,
        engineerInfoEdit
    } from "../../api/api";
    import { querySysRegion } from "../../api/system";
    import {getPermission} from '../../api/authRequest';
    import PinyinMatch from 'pinyin-match';
    export default {
        inject:['reload'],
        name: 'engineerManage',
        components: {
        },
        data () {
            var validatePhone = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入手机号码'));
                } else {
                    if(!value.match(/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/)){
                        callback(new Error('手机号码格式错误'));
                    }
                    callback();
                }
            };
            return {
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                dialogMenuStatus: "",
                textMenu: {
                    update: "修改工程师",
                    create: "新增工程师"
                },
                choose:{},
                dataList:[
                    {
                        title: '工程师类别:',
                        list: ["上门工程师", "门店工程师"]
                    },
                    {
                        title: '启用状态:',
                        list: ["启用", "禁用"]
                    }
                ],
                dislogCreate:false,
                labelPosition:'left',
                EngineerForm:{
                    type: '',
                    grade: '',
                    loginName: '',
                    age:'',
                    packType: '',
                    accountState:'',
                    state: 1,
                    password:'',
                    email:'',
                    phone:'',
                    shop:'',
                    name: "",
                    sex: "",
                    jobNo:""
                },
                EngineerFormRules:{
                    type: [{ required: true, message: "请选择工程师类型", trigger: "blur" }],
                    shop: [{ required: true, message: "请选择所属门店", trigger: "blur" }],
                    name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                    sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
                    accountState: [{ required: true, message: "请选择城市", trigger: "blur" }],
                    password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                    loginName: [{ required: true, message: "请输入账号", trigger: "blur" }],
                    packType: [{ required: true, message: "请选择基础包", trigger: "blur" }],
                    grade: [{ required: true, message: "请选择工程师等级", trigger: "blur" }],
                    phone: [{ required: true,validator: validatePhone, trigger: 'blur' }],
                    age: [{ required: true, message: "请选择工程师年龄", trigger: "blur" }],
                    jobNo: [{ required: true, message: "请输入工号", trigger: "blur" }],
                },
                searchForm:{
                    name: '',
                    number: '',
                    shop:'',
                    type:'',
                    state:1
                },
                returnData: [],
                engineerTypeList:[],
                engineerAccountList:[],
                enginnerGradeList:[],
                copy:[],
                engineersList:[],
                enginnerPackTypeList:[],
                shopListData:[],
                regionList:[],
                basicsAuth:{
                    storeEngineerAdd:false,
                    storeEngineerEdit:false
                }
            }
        },
        mounted () {
            this.basicsAuth.storeEngineerAdd= getPermission('/api/EngineerInfo/engineerInfoAdd');
            this.basicsAuth.storeEngineerEdit= getPermission('/api/EngineerInfo/engineerInfoEdit');
         },
        created(){
            this.getShopList()
            this.getEngineerList()
            this.getEngineerInfoByUser()
            this.getEngineerInfoTypeList()
            this.getEngineerGreadeList()
            this.getEngineerPackTypeList()
            this.getEngineerDataList();
            this.getQuerySysRegion();
        },
        methods: {
            //强制刷新
            changeName(e){
                console.log(e);
                this.searchForm.name = e;
                this.$forceUpdate();
            },
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.name,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.name = val;
                    this.engineersList = result;
                }else{
                    this.engineersList = this.copy;
                    this.searchForm.name = "";
                }
            },
            clearFrom(){
                this.searchForm = {
                    name: '',
                    number: '',
                    shop:'',
                    type:'',
                    state:1
                };
                this.getEngineerList();
            },
            //获取工程师
            getEngineerDataList(){
                let params = {
                    startRow:1,
                    pageSize:10000,
                    state:1
                }
                engineerList(params).then(res => {
                    if (res.data.status==100) {
                        this.engineersList = res.data.results.list;
                        this.copy = Object.assign(this.engineersList);
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            getQuerySysRegion(){
                let params = {
                    parentId:0
                }
                querySysRegion(params).then(res => {
                    if (res.data.status==100) {
                        this.regionList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getEngineerList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getEngineerList()
            },
            //获取门店列表
            getShopList(){
                let para={};
                shopStoreList(para).then(res => {
                    if (res.data.status==100) {
                      this.shopListData = res.data.results;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取工程师列表
            getEngineerList(){
                let para={
                    name:this.searchForm.name,
                    loginName:this.searchForm.number,
                    type:this.searchForm.type,
                    shop:this.searchForm.shop,
                    state:this.searchForm.state == -1 ? 0 : 1,
                    startRow:this.pages.page,
                    pageSize:this.pages.pageSize
                };
                engineerList(para).then(res => {
                    if (res.data.status==100) {
                        this.returnData = res.data.results.list;
                        this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取工程师账号
            getEngineerInfoByUser(){
                let para={};
                engineerInfoByUser(para).then(res => {
                    if (res.data.status==100) {
                        this.engineerAccountList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取工程师类型
            getEngineerInfoTypeList(){
                let para={};
                engineerInfoTypeList(para).then(res => {
                    if (res.data.status==100) {
                        this.engineerTypeList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取工程师等级
            getEngineerGreadeList(){
                let para={};
                engineerGreadeList(para).then(res => {
                    if (res.data.status==100) {
                        this.enginnerGradeList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取工程师基础包
            getEngineerPackTypeList(){
                let para={};
                packTypeList(para).then(res => {
                    if (res.data.status==100) {
                        this.enginnerPackTypeList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //清空dialog
            emptyDialog() {
                this.$refs['EngineerForm'].resetFields();
                this.dislogCreate = false;
                Object.keys(this.EngineerForm).forEach(key => this.EngineerForm[key] = ''); //清空对象值
            },
            //新建工程师
            createEngineer() {
              this.dislogCreate = true
              this.dialogMenuStatus = "create";

            },
            //提交前验证
            verify(){
                let isTrue = true;
                if(this.EngineerForm.type == ''){
                    this.$message({
                        message: '请选择工程师类型',
                        type: "warning"
                    });
                    return isTrue = false;
                }
                if(this.EngineerForm.name == ''){
                    this.$message({
                        message: '请输入姓名',
                        type: "warning"
                    });
                    return isTrue = false;
                }
                if(this.EngineerForm.accountState == ''){
                    this.$message({
                        message: '请选择城市',
                        type: "warning"
                    });
                    return isTrue = false;
                }
                if(this.EngineerForm.loginName == ''){
                    this.$message({
                        message: '请输入工程师账号',
                        type: "warning"
                    });
                    return isTrue = false;
                }
                if(this.EngineerForm.grade == ''){
                    this.$message({
                        message: '请选择工程师等级',
                        type: "warning"
                    });
                    return isTrue = false;
                }
                if(this.EngineerForm.phone == ''){
                    this.$message({
                        message: '请输入手机号码',
                        type: "warning"
                    });
                    return isTrue = false;
                }
                if(!this.EngineerForm.phone.match(/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/)){
                    this.$message({
                        message: '手机号码格式错误',
                        type: "warning"
                    });
                    return isTrue = false;
                }
                if(this.EngineerForm.shop == ''){
                    this.$message({
                        message: '请选择门店',
                        type: "warning"
                    });
                    return isTrue = false;
                }
                if(this.EngineerForm.sex == ''){
                    this.$message({
                        message: '请选择性别',
                        type: "warning"
                    });
                    return isTrue = false;
                }
                if(this.dialogMenuStatus=='create'){
                    if(this.EngineerForm.password == ''){
                        this.$message({
                            message: '请输入工程师密码',
                            type: "warning"
                        });
                        return isTrue = false;
                    }
                }

                if(this.EngineerForm.packType == ''){
                    this.$message({
                        message: '请选择基础包',
                        type: "warning"
                    });
                    return isTrue = false;
                }
                if(this.EngineerForm.email == ''){
                    this.$message({
                        message: '请输入邮箱',
                        type: "warning"
                    });
                    return isTrue = false;
                }
                return isTrue;
            },
            //确认新建
            createData(formname){
                this.$refs[formname].validate((valid) => {
                    if(valid){
                        let para={
                            type: this.EngineerForm.type,
                            grade: this.EngineerForm.grade,
                            loginName: this.EngineerForm.loginName,
                            age:this.EngineerForm.age,
                            packType: this.EngineerForm.packType,
                            accountState:this.EngineerForm.accountState,
                            state: this.EngineerForm.state == -1 ? 0 : this.EngineerForm.state,
                            password:this.EngineerForm.password,
                            email:this.EngineerForm.email,
                            phone:this.EngineerForm.phone,
                            shop:this.EngineerForm.shop,
                            name:this.EngineerForm.name,
                            sex:this.EngineerForm.sex,
                            jobNo:this.EngineerForm.jobNo
                        };
                        engineerInfoAdd(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: '新建成功！',
                                    type: "success"
                                });
                                this.getEngineerList();

                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                            this.emptyDialog();
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    }else {
                        console.log('验证未通过');
                        return false;
                    }
                });

            },
            //修改工程师
            exitBtn(index,item) {
                this.dislogCreate = true
                this.dialogMenuStatus = "update";
                this.EngineerForm = Object.assign({}, item);
                console.log(this.EngineerForm)
                this.EngineerForm.accountState = Number(this.EngineerForm.accountState); //下拉框默认选中值为字符串
                this.EngineerForm.password = "";
            },
            //确认修改
            updateData(formname){
                this.$refs[formname].validate((valid) => {
                    if(valid){
                        let para={
                            type: this.EngineerForm.type,
                            grade: this.EngineerForm.grade,
                            loginName: this.EngineerForm.loginName,
                            age:this.EngineerForm.age,
                            packType: this.EngineerForm.packType,
                            accountState:this.EngineerForm.accountState,
                            state: this.EngineerForm.state == -1 ? 0 : this.EngineerForm.state,
                            password:this.EngineerForm.password,
                            email:this.EngineerForm.email,
                            phone:this.EngineerForm.phone,
                            shop:this.EngineerForm.shop,
                            name:this.EngineerForm.name,
                            sex:this.EngineerForm.sex,
                            id:this.EngineerForm.id,
                            jobNo:this.EngineerForm.jobNo
                        };
                        engineerInfoEdit(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: '修改成功！',
                                    type: "success"
                                });
                                this.getEngineerList();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                            this.emptyDialog();
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    }else {
                        console.log('验证未通过');
                        return false;
                    }
                });

            },
            handle:function(index,key){
                var _this = this;
                var count = 0;
                var item=this.category[index].items;
                item.filter(function(v,i){
                    if(i==key){
                        v.active=true;
                        _this.condition.filter(function(v2,i){
                            if(v.name==v2.name){
                                _this.condition.splice(i,1);
                                count--;
                            }
                        });
                        Vue.set(_this.condition,count++,v);
                    }
                });
            },
            remove:function(index){
                var item=this.category[index].items;
                item.filter(function (v1,key) {
                    v1.active=false;
                    this.condition.filter(function(v2,i){
                        if(v1.name==v2.name){
                            this.condition.splice(i,1);
                            count--;
                        }
                    });
                });
            },
            allIn:function(index){
                var item=this.category[index].items;
                item.filter(function (v,key) {
                    v.active=true;
                    this.condition.filter(function(v2,i){
                        if(v.name==v2.name){
                            this.condition.splice(i,1);
                            count--;
                        }
                    });
                    Vue.set(this.condition,count++,v);
                });
            },
            refresh() {
                this.getEngineerList()
                this.reload()
            },
            onSubmit() {
                this.getEngineerList()
            }
        }
    }
</script>

<style lang="scss" type="text/css" scoped>
  #engineerManage{font-size: 14px;
    .headerT{margin:8px 0 15px 0;width: 80px;}

  }
  #section {-webkit-box-shadow: 0px 0px 4px rgba(0,0,0,.2);box-shadow: 0px 0px 4px rgba(0,0,0,.2);padding: 15px 20px;}
  #choose {margin: 0 auto;line-height: 24px;}
  #type {width: 100%;padding: 10px 0 16px 0px;}
  #type li {color: #8a8a8a;line-height: 34px;}
  #type a {margin: 0 12px 0 10px;color: #000;border:1px solid transparent;}
  #choose mark {
    position: relative;
    display: inline-block;
    height: 24px;
    line-height: 24px;
    border: 1px solid #28a5c4;
    color: #28a5c4;
    margin: -1px 5px 5px 0;
    background: none;
    padding: 0 30px 0 6px;
    text-indent: 0;
    /*top: 5px;*/
  }
  #choose mark a {
    position: absolute;
    /*top: -5px;*/
    right: 0px;
    display: inline-block;
    width: 18px;
    height: 22px;
    background: #28a5c4;
    color: #fff;
    line-height: 22px;
    font-size: 16px;
    text-align: center;
    }
    #type a.active {/*border:1px solid #1abc9c;*/color:#28a5c4;}

</style>



// WEBPACK FOOTER //
// storeEngineerManage.vue?19123df0